import { motion, AnimatePresence } from "framer-motion";
import { AIRPOGS, RARITY } from "@/constants/airpogs";

// 🎉 "You caught an AIR.POG!" banner — tap to jump to the collection.
export const CaughtPogBanner = ({ pog, onOpen }) => (
  <AnimatePresence>
    {pog && (() => {
      const meta = AIRPOGS.find((p) => p.id === pog.pog_id);
      if (!meta) return null;
      const r = RARITY[pog.rarity] || RARITY.common;
      return (
        <motion.button
          data-testid="caught-pog-banner"
          initial={{ opacity: 0, y: -24, scale: 0.9 }} animate={{ opacity: 1, y: 0, scale: 1 }} exit={{ opacity: 0, y: -24, scale: 0.9 }}
          onClick={onOpen}
          className="absolute top-24 sm:top-28 left-1/2 -translate-x-1/2 z-[1900] glass-strong rounded-2xl pl-2 pr-4 py-2 shadow-2xl flex items-center gap-3 border"
          style={{ borderColor: r.ring }}
        >
          <img src={meta.img} alt={meta.name} className="w-12 h-12 object-contain" style={{ filter: `drop-shadow(0 0 10px ${r.glow})` }} />
          <div className="text-left">
            <p className="text-[10px] font-bold uppercase tracking-wider" style={{ color: r.ring }}>{pog.is_new ? "New AIR.POG caught!" : "Caught a dupe!"} · {r.label}</p>
            <p className="font-heading font-extrabold text-sm text-white leading-tight">{meta.name} 🦖</p>
            <p className="text-[10px] text-slate-400">Tap to see your collection</p>
          </div>
        </motion.button>
      );
    })()}
  </AnimatePresence>
);
